export default "__VITE_ASSET__DKdwfSnZ__"